import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledNotSupportedView } from './StyledNotSupportedView';

export const NotSupported = () => {
  const { t } = useTranslation();
  return <StyledNotSupportedView>{t('load.notSupported')}</StyledNotSupportedView>;
};
